import NavLang from '../nav-main/src/v2/nav-lang';

/* istanbul ignore next */
NavLang.install = function(Vue) {
  Vue.component(NavLang.name, NavLang);
};

export default NavLang;
